import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'
import Criteria from '../../components/criteria'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/preAuditProcess/result/evaluation') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('preAuditResultEvaluation', record)
        } else {
            record = Session.get('preAuditResultEvaluation') || {}
        }
    }
    return record
}

class PreAuditResultEvaluation extends WizContainer {

    componentName = 'PreAuditResultEvaluation'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record,
            criteria: []
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/evaluationCriteria',
            payload: {
                key: 'preAuditEvaluationCriteria@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        })
    }

    _onUpdateCriteria = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/updateCriteria',
            payload: {
                key: 'updateCriteria@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        })
    }

    _realTimeUpdateCriteria = (params = {}) => {
        this.doAction({
            path: 'processRealTime/updateCriteria',
            payload: {
                key: 'updateCriteria@realTime',
                apiParams: { ...params }
            }
        })
    }

    _importExcel = (list) => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/importCriteria',
            payload: {
                key: 'importCriteria@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1,
                    list
                }
            }
        })
    }

    _onSave = (list = []) => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/saveCriteria',
            payload: {
                key: 'saveCriteria@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1,
                    list
                }
            }
        })
    }

    propsAndStateOnChange = {
        evaluationCriteria: this._evaluationCriteriaOnChange.bind(this),
        updateCriteria: this._updateCriteriaOnChange.bind(this),
        importCriteria: this._importCriteriaOnChange.bind(this),
        saveCriteria: this._saveCriteriaOnChange.bind(this),
    }

    _evaluationCriteriaOnChange(nextProps, nextState) {
        if (nextProps.evaluationCriteria.code === 1) {
            nextState.criteria = nextProps.evaluationCriteria.data
        } else {
            wizNotice.error(nextProps.evaluationCriteria.msg)
        }
        return true
    }

    _updateCriteriaOnChange(nextProps, nextState) {
        if (nextProps.updateCriteria.code === 1) {
            nextState.criteria = nextProps.updateCriteria.data
        } else {
            wizNotice.error(nextProps.updateCriteria.msg)
        }
        return true
    }

    _importCriteriaOnChange(nextProps, nextState) {
        if (nextProps.importCriteria.code === 1) {
            nextState.criteria = nextProps.importCriteria.data
        } else {
            wizNotice.error(nextProps.importCriteria.msg)
        }
        return true
    }

    _saveCriteriaOnChange(nextProps, nextState) {
        if (nextProps.saveCriteria.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.saveCriteria.msg)
        }
        return true
    }

    render() {
        let { criteria, record } = this.state
        let { counselingProcessLoading } = this.props
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <Criteria
                    data={criteria}
                    title='预审核标准'
                    type='evaluation'
                    onSave={this._onSave}
                    onUpdateCriteria={this._onUpdateCriteria}
                    realTimeUpdate={this._realTimeUpdateCriteria}
                    importExcel={this._importExcel}
                />
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const evaluationCriteria = modelUtils.getModelEntity(counselingProcess, 'preAuditEvaluationCriteria@' + processContentId)
    const updateCriteria = modelUtils.getModelEntity(counselingProcess, 'updateCriteria@' + processContentId)
    const importCriteria = modelUtils.getModelEntity(counselingProcess, 'importCriteria@' + processContentId)
    const saveCriteria = modelUtils.getModelEntity(counselingProcess, 'saveCriteria@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        evaluationCriteria,
        updateCriteria,
        importCriteria,
        saveCriteria,
        ...loading
    }
}

export default connect(mapStateToProps)(PreAuditResultEvaluation)


